import { Box, Typography } from '@mui/material';
import { 
  TwitterShareButton, 
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  RedditShareButton,
  RedditIcon,
} from 'react-share';

function Header() {
  const shareUrl = 'https://qrcolor.xyz';
  const title = 'Create colorful QR codes instantly with QR Color ✨';

  return (
    <Box 
      component="header" 
      sx={{ 
        textAlign: 'center',
        mb: 6,
      }}
    >
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: 700,
          mb: 2,
          background: 'linear-gradient(45deg, #6366f1 30%, #8b5cf6 90%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(45deg, #6366f1 30%, #8b5cf6 90%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            filter: 'brightness(1.2)',
            opacity: 0,
            transition: 'opacity 0.3s ease',
          },
          '&:hover::after': {
            opacity: 1,
          },
        }}
      >
        QR Color
      </Typography>
      
      <Typography
        variant="h6"
        color="text.secondary"
        sx={{ mb: 3, maxWidth: 600, mx: 'auto' }}
      >
        Create beautiful, customizable QR codes in seconds. Free forever.
      </Typography>

      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
        <TwitterShareButton url={shareUrl} title={title}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        
        <LinkedinShareButton url={shareUrl} title={title}>
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
        
        <RedditShareButton url={shareUrl} title={title}>
          <RedditIcon size={32} round />
        </RedditShareButton>
      </Box>
    </Box>
  );
}

export default Header;
